// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

import PageLayer from "@/Layouts/views/PageLayer";
import GeneralSalesManagerWashoutLayer from "@/Washouts/views/Layers/Sales/GeneralManagers/GeneralSalesManagerWashoutLayer";

const POSITION = "General Sales Manager";

export default function GeneralSalesManagerWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"General Sales Manager Washouts"} icon={Icon}>
			<GeneralSalesManagerWashoutLayer />
		</PageLayer>
	);
}
